{
  "close": "Aizvērt",
  "notifications": "Paziņojumi"
}
